// The action bar (ARCH §28.8, D-TF-191): one short line centred above the hotbar that
// fades after a moment — "The flock is too crowded to breed here." and, from Part X on,
// every lesson prompt. Client-only (ENG-1). The line itself is kept by the Game
// (`showActionBar` / `lastActionBar`) so tests read what was said, not what is painted.
import { h } from '../h';
import type { Game } from '../../boot';

/** How long a line stays up, in ms. */
const SHOW_MS = 2500;

export class ActionBar {
  readonly el: HTMLElement;
  private shownSerial = -1;
  private hideAt = 0;

  constructor() {
    this.el = h('div', { class: 'bb-actionbar', 'data-testid': 'action-bar' });
    this.el.style.display = 'none';
  }

  update(game: Game): void {
    const { text, serial } = game.actionBar;
    const now = performance.now();
    if (serial !== this.shownSerial) {
      this.shownSerial = serial;
      this.el.textContent = text;
      this.el.style.display = text ? 'block' : 'none';
      this.hideAt = now + SHOW_MS;
    } else if (this.el.style.display !== 'none' && now >= this.hideAt) {
      this.el.style.display = 'none';
    }
  }
}
